"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    schema: function() {
        return schema;
    },
    schemaMap: function() {
        return schemaMap;
    }
});
var _motorSettings = /*#__PURE__*/ _interopRequireDefault(require("./external/MotorSettings"));
var _schemaUtils = require("./schemaUtils");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var schema = {
    "motorSettings": _motorSettings.default,
    "parameters": [
        {
            "name": "friendlyName",
            "unit": "string",
            "description": "The friendly name of the axis."
        },
        {
            "name": "uuid",
            "unit": "string",
            "description": "The unique identifier of the axis."
        },
        {
            "name": "controllerId",
            "unit": "string",
            "description": "The unique identifier of the controller that contains the axis."
        },
        {
            "name": "axisColor",
            "unit": "string",
            "format": "oneOf",
            "values": [
                "green",
                "yellow",
                "red",
                "blue"
            ],
            "default": "green",
            "description": "The color reference of the axis, parent drive."
        },
        {
            "name": "mmPerRotation",
            "unit": "number",
            "format": "float",
            "minimum": 0.1,
            "maximum": 1000,
            "axisTypeMapping": {
                "belt": 150,
                "enclosed_timing_belt": 208,
                "rack_and_pinion": 157.08,
                "rack_and_pinion_v2": 141.37,
                "ball_screw": 10,
                "enclosed_ball_screw": 16,
                "enclosed_lead_screw": 4,
                "indexer": 85,
                "indexer_v2": 36,
                "electric_cylinder": 6,
                "belt_conveyor": 73.563,
                "roller_conveyor": 157.7,
                "belt_rack": 125,
                "heavy_duty_roller_conveyor": 123.3,
                "timing_belt_conveyor": 100,
                "telescopic_column": 8.38095
            },
            "default": 150,
            "description": "Linear displacement in mm for a single rotation of the motor."
        },
        {
            "name": "axisType",
            "unit": "string",
            "format": "oneOf",
            "values": [
                "belt",
                "rack_and_pinion",
                "rack_and_pinion_v2",
                "ball_screw",
                "enclosed_ball_screw",
                "enclosed_lead_screw",
                "indexer",
                "indexer_v2",
                "electric_cylinder",
                "belt_conveyor",
                "roller_conveyor",
                "pneumatic",
                "pneumatic_bag_gripper",
                "ac_motor_with_vfd",
                "enclosed_timing_belt",
                "belt_rack",
                "heavy_duty_roller_conveyor",
                "timing_belt_conveyor",
                "telescopic_column",
                "custom"
            ],
            "configCheckerCompatibility": {
                "compatible": [
                    "belt",
                    "enclosed_timing_belt",
                    "rack_and_pinion",
                    "rack_and_pinion_v2",
                    "ball_screw",
                    "enclosed_ball_screw",
                    "enclosed_lead_screw",
                    "belt_rack"
                ]
            },
            "maxSpeedMapping": {
                "ball_screw": 200,
                "enclosed_ball_screw": 200,
                "enclosed_lead_screw": 50,
                "electric_cylinder": 300,
                "telescopic_column": 100
            },
            "default": "belt",
            "description": "The actuator type of the axis."
        },
        {
            "name": "multiplier",
            "unit": "number",
            "format": "oneOf",
            "values": [
                1,
                1 / 5
            ],
            "axisTypeCompatibility": {
                "compatible": [
                    "belt",
                    "enclosed_timing_belt",
                    "rack_and_pinion",
                    "rack_and_pinion_v2",
                    "indexer",
                    "belt_rack",
                    "heavy_duty_roller_conveyor"
                ]
            },
            "default": 1,
            "description": "Multiplier for the gain. Translates the presence of a 1/5 gearbox on the actuator for example."
        },
        {
            "name": "tuningProfile",
            "unit": "string",
            "format": "oneOf",
            "values": [
                "default",
                "conveyor_turntable",
                "custom"
            ],
            "default": "default",
            "description": "Tuning profile of the motor. All motors belonging to the same actuator should share the same profile."
        },
        {
            "name": "motorSize",
            "unit": "string",
            "format": "oneOf",
            // "values": Object.values(MotorSettings).map((motor) => motor.value),  // Object.values is not supported prior node v7 (some boxes have v6)
            "values": Object.keys(_motorSettings.default).map(function(key) {
                return _motorSettings.default[key].value;
            }),
            "default": _motorSettings.default["Medium Servo"].value,
            "description": "The size of the motor. All motors belonging to the same actuator should be the same size."
        },
        {
            "name": "motorCurrent",
            "unit": "number",
            "format": "float",
            "skipValueValidation": true,
            "default": _motorSettings.default["Medium Servo"].motorCurrent.default,
            "description": "The current to power the motor with, in Amps."
        },
        {
            "name": "brake",
            "unit": "string",
            "format": "oneOf",
            "values": [
                "none",
                "present"
            ],
            "axisTypeCompatibility": {
                "incompatible": [
                    "electric_cylinder",
                    "telescopic_column"
                ]
            },
            "default": "none",
            "description": "The presence or absence of a brake on the axis."
        },
        {
            "name": "rotation",
            "unit": "integer",
            "format": "oneOf",
            "values": [
                -1,
                1
            ],
            "default": 1,
            "description": "The rotation on the axis."
        },
        {
            "name": "childrenDrives",
            "unit": [
                {
                    "name": "uuid",
                    "unit": "string",
                    "description": "The unique identifier of the drive."
                },
                {
                    "name": "color",
                    "unit": "string",
                    "format": "oneOf",
                    "values": [
                        "green",
                        "yellow",
                        "red",
                        "blue"
                    ],
                    "default": "green",
                    "description": "The color reference of the child drive."
                },
                {
                    "name": "rotation",
                    "unit": "integer",
                    "format": "oneOf",
                    "values": [
                        -1,
                        1
                    ],
                    "default": 1,
                    "description": "The rotation of the child motor."
                }
            ],
            "format": "array",
            "default": [],
            "description": "The children drives of the axis, if any."
        },
        {
            "name": "homingSpeed",
            "isOptional": true,
            "unit": "number",
            "format": "float",
            "minimum": 1,
            "default": 68.8,
            "description": "The speed of the homing motion of the actuator in mm/s",
            "axisTypeMapping": {
                "belt": 68.8,
                "enclosed_timing_belt": 68.8,
                "rack_and_pinion": 68.8,
                "rack_and_pinion_v2": 68.7,
                "ball_screw": 64.6,
                "enclosed_ball_screw": 66.3,
                "enclosed_lead_screw": 50,
                "indexer": 68.5,
                "indexer_v2": 67.8,
                "electric_cylinder": 5,
                "belt_conveyor": 68.4,
                "roller_conveyor": 68.8,
                "belt_rack": 68.7,
                "heavy_duty_roller_conveyor": 68.7,
                "timing_belt_conveyor": 68.6,
                "telescopic_column": 63.7,
                "custom": 69
            }
        }
    ]
};
var parameterMap = (0, _schemaUtils.generateParameterMapFromArray)(schema.parameters);
parameterMap.childrenDrives.unitMap = (0, _schemaUtils.generateParameterMapFromArray)(parameterMap.childrenDrives.unit);
var schemaMap = {
    motorSettings: schema.motorSettings,
    parameters: parameterMap
};
